"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mark_signer_complete = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
/**
 * Mark current signer as complete
 * This endpoint:
 * - Verifies location via server-side LetsTrade Integration API (prevents spoofing)
 * - Updates signer's completedAt timestamp with verified location
 * - Stores FaceTec verification status and session ID
 * - Transitions status to SIGNING (first completion) or COMPLETED (all signers done)
 * - Sets first_signed_at timestamp on document
 * - Sends completion emails when all signers complete
 */
function mark_signer_complete(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        const response = yield new api_1.API().apiPut({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: `mark-signer-complete`,
            content: {
                document_id: request.document_id,
                location: request.location,
                facetec_verified: request.facetec_verified,
                facetec_session_id: request.facetec_session_id,
                test_mode_used: request.test_mode_used,
                verification_status: request.verification_status,
            },
            authorization: `${token}`,
            customHeaders: request.facetec_session_token
                ? {
                    "x-facetec-session": request.facetec_session_token,
                }
                : undefined,
        });
        return response;
    });
}
exports.mark_signer_complete = mark_signer_complete;
